import styled from 'styled-components/macro';

const HiStickyFooter = styled('div')`
  position: fixed;
  height: 68px;
  width: 100%;
  z-index: 10;

  background-color: #ffffff;
  box-shadow: 0px -1px 6px 0px #20272b33;
  bottom: 0;
  left: 0;
  right: 0;

  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default HiStickyFooter;
